import { UIEvent, useEffect, useState, ChangeEvent } from 'react';
import {
  CouponIcon,
  CrossIcon,
  ExclamationMarkHexagonFillIcon,
  CheckCircleIcon,
} from '@grupoboticario/flora-react-icons';
import { app, cart } from 'core';
import { ButtonGhost, ButtonIcon, ButtonSolid, Card, CouponBase, Input, Text } from 'ui/components';

export const Coupon = () => {
  const [isCouponOpen, toggleCoupon] = useState(false);
  const [couponValue, setCouponValue] = useState('');
  const { clearCoupon, setCoupon, setIsValidCoupon } = cart.commands.useCartCommand();
  const {
    data: { coupon },
    isError,
    isSuccess,
  } = cart.hooks.useCoupon();
  const { trackClick } = app.commands.useAppCommand();
  const isCouponEmptyOrInvalid = !coupon?.isValidCoupon;
  const isInvalidCoupon = coupon?.isValidCoupon === false;

  const addCoupon = () => {
    setCoupon(couponValue);
  };

  const clearCouponInputValue = (event: UIEvent<HTMLButtonElement>) => {
    trackClick(event, 'event', {
      eventAction: 'clique:botao',
      eventCategory: 'eud-portal:carrinho:cupom',
      eventLabel: 'limpar-campo',
    });

    setCouponValue('');
  };

  const resetIsValidCoupon = () => {
    if (isInvalidCoupon && isError) {
      setIsValidCoupon(null);
    }
  };

  const toggleCouponVisibility = () => {
    toggleCoupon(!isCouponOpen);
  };

  const handleCouponValue = (event: ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = event.currentTarget;

    setCouponValue(inputValue);
  };

  useEffect(() => {
    const couponIsEmpty = !coupon?.couponIsApplied && !coupon?.couponNumber;

    if (isSuccess && couponIsEmpty) {
      setCouponValue('');

      toggleCoupon(false);
    }
  }, [coupon?.couponNumber, coupon?.couponIsApplied, isSuccess]);

  if (!isCouponOpen && !coupon?.couponIsApplied) {
    return (
      <CouponBase.Container>
        <Card radius="rounded" spacing="medium">
          <CouponBase.Wrapper>
            <CouponIcon size="20" />
            <Text>Cupom de desconto ou vale-brinde</Text>
            <CouponBase.Button onClick={toggleCouponVisibility} size="small">
              Adicionar
            </CouponBase.Button>
          </CouponBase.Wrapper>
        </Card>
      </CouponBase.Container>
    );
  }

  if (isCouponEmptyOrInvalid) {
    return (
      <CouponBase.Container>
        <Card radius="rounded" spacing="medium">
          <CouponBase.Wrapper>
            <CouponBase.ActiveInputWrapper>
              <Input
                error={isInvalidCoupon}
                onChange={handleCouponValue}
                onClick={resetIsValidCoupon}
                placeholder="Código do cupom ou vale-brinde"
                renderSuffix={
                  !!couponValue.length && (
                    <ButtonIcon
                      aria-label="limpar pesquisa"
                      data-testid="clear-button"
                      onClick={clearCouponInputValue}
                      size="small"
                    >
                      <CrossIcon size={16} />
                    </ButtonIcon>
                  )
                }
                value={couponValue}
              />

              {isInvalidCoupon && (
                <CouponBase.CouponErrorWrapper>
                  <CouponBase.ErrorIconWrapper>
                    <ExclamationMarkHexagonFillIcon size={24} />
                  </CouponBase.ErrorIconWrapper>

                  <Text variant="auxiliar-small">
                    Código inválido ou tivemos algum problema! Por favor, confira o código e tente
                    novamente
                  </Text>
                </CouponBase.CouponErrorWrapper>
              )}

              <ButtonSolid disabled={isInvalidCoupon || !couponValue.length} onClick={addCoupon}>
                Adicionar cupom ou vale-brinde
              </ButtonSolid>
            </CouponBase.ActiveInputWrapper>
          </CouponBase.Wrapper>
        </Card>
      </CouponBase.Container>
    );
  }

  return (
    <CouponBase.Container>
      <Card radius="rounded" spacing="medium">
        <CouponBase.Wrapper>
          <CouponBase.SuccessfulWrapper>
            <CouponBase.IconTextSuccessWrapper>
              <CouponBase.SuccessIconWrapper>
                <CheckCircleIcon />
              </CouponBase.SuccessIconWrapper>
              <CouponBase.SuccessTextWrapper>
                <Text variant="body-medium-short">Código adicionado</Text>
                <Text variant="auxiliar-small">Saiba detalhes na etapa de pagamento</Text>
              </CouponBase.SuccessTextWrapper>
            </CouponBase.IconTextSuccessWrapper>
            <ButtonGhost onClick={clearCoupon} size="small">
              Excluir
            </ButtonGhost>
          </CouponBase.SuccessfulWrapper>
        </CouponBase.Wrapper>
      </Card>
    </CouponBase.Container>
  );
};
